// =============================================================================
// Sidebar — rail + hover + drawer mobile, no padrão do parque.
//
// O menu é DADOS, não JSX espalhado: cada item traz a permissão que o mostra.
// Isso alimenta a renderização E a busca rápida de uma vez só — ao adicionar
// uma tela, edita-se um array, e ela já aparece na busca sem trabalho extra.
// (Mesma estrutura do Portal Comercial.)
// =============================================================================

import { Fragment, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';
import Changelog from './Changelog';
import { VERSAO } from '../changelog';

export default function Sidebar() {
  const { usuario, logout, temPermissao } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [busca, setBusca] = useState('');
  const [verNovidades, setVerNovidades] = useState(false);
  const location = useLocation();

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  useEffect(() => {
    const fechar = () => setMobileOpen(false);
    window.addEventListener('orientationchange', fechar);
    window.addEventListener('resize', fechar);
    return () => {
      window.removeEventListener('orientationchange', fechar);
      window.removeEventListener('resize', fechar);
    };
  }, []);

  useEffect(() => {
    if (!mobileOpen) return;
    const anterior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = anterior; };
  }, [mobileOpen]);

  const p = (...chaves) => temPermissao(...chaves);

  // O menu é DADOS: cada item traz a permissão que o mostra. Isso alimenta a
  // renderização E a busca de uma vez só.
  const SECOES = [
    { label: 'Vender', itens: [
      { to: '/orcamento', label: 'Novo orçamento', icon: 'bi-cart-plus', show: p('pedidos_criar') },
      { to: '/rascunhos', label: 'Rascunhos', icon: 'bi-pencil-square', show: p('pedidos_criar') },
      { to: '/pedidos', label: 'Pedidos', icon: 'bi-receipt', show: p('pedidos_ver_proprios', 'pedidos_ver_todos') },
    ] },
    { label: 'Administração', itens: [
      { to: '/admin/usuarios', label: 'Usuários', icon: 'bi-person-gear', show: p('admin_usuarios') },
      { to: '/admin/perfis', label: 'Perfis', icon: 'bi-shield-lock', show: p('admin_perfis') },
    ] },
  ];

  const buscaNorm = busca.trim().toLowerCase();
  const secoesVisiveis = SECOES
    .map((sec) => ({
      ...sec,
      itens: sec.itens.filter((it) => it.show && (
        !buscaNorm
        || it.label.toLowerCase().includes(buscaNorm)
        || sec.label.toLowerCase().includes(buscaNorm)
      )),
    }))
    .filter((sec) => sec.itens.length > 0);

  return (
    <>
      <div className="mobile-header">
        <button onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}>
          <i className={`bi ${mobileOpen ? 'bi-x-lg' : 'bi-list'}`} />
        </button>
        <img src={logo} className="sidebar-logo" alt="Centrão" />
        <div className="sidebar-title">Fênix<span>Centrão</span></div>
      </div>

      <div className={`sidebar-overlay ${mobileOpen ? 'open' : ''}`} onClick={() => setMobileOpen(false)} />

      <nav className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={logo} className="sidebar-logo" alt="Centrão" />
          <div className="sidebar-title sidebar-label">Fênix<span>Centrão</span></div>
        </div>

        <div className="sidebar-search sidebar-label">
          <i className="bi bi-search" />
          <input
            type="text"
            placeholder="Buscar menu…"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            aria-label="Buscar no menu"
          />
          {busca && (
            <button type="button" className="sidebar-search__clear"
                    onClick={() => setBusca('')} aria-label="Limpar busca">
              <i className="bi bi-x" />
            </button>
          )}
        </div>

        <div className="sidebar-nav">
          {secoesVisiveis.map((sec) => (
            <Fragment key={sec.label}>
              <div className="sidebar-section sidebar-label">{sec.label}</div>
              {sec.itens.map((it) => (
                <NavLink key={it.to} to={it.to} title={it.label}>
                  <i className={`bi ${it.icon}`} />
                  <span className="nav-label sidebar-label">{it.label}</span>
                </NavLink>
              ))}
            </Fragment>
          ))}
          {buscaNorm && secoesVisiveis.length === 0 && (
            <div className="sidebar-empty sidebar-label">Nenhum menu encontrado</div>
          )}
        </div>

        <div className="sidebar-bottom">
          <div className="sidebar-user-info sidebar-label">
            <i className="bi bi-person-circle me-2" />{usuario?.nome}
            <div className="sidebar-user-grupo">{usuario?.perfil_nome}</div>
          </div>
          <div className="sidebar-acoes-row">
            <button className="sidebar-acao-btn" onClick={logout} title="Sair">
              <i className="bi bi-box-arrow-left" />
              <span className="sidebar-label">Sair</span>
            </button>
          </div>
          {/* A versao fica onde o suporte pergunta por ela. Clicavel de
              proposito: saber o numero sem saber o que mudou nao ajuda
              ninguem. */}
          <button type="button" className="sidebar-versao" title="Ver o que mudou"
                  onClick={() => setVerNovidades(true)}>
            <i className="bi bi-fire" />
            <span className="sidebar-label">versão {VERSAO}</span>
          </button>
        </div>
      </nav>

      {verNovidades && <Changelog aoFechar={() => setVerNovidades(false)} />}
    </>
  );
}
